/*
 * @Author: Mr Chang
 * @Date: 2020-08-30 13:09:21
 * @LastEditTime: 2020-09-02 11:17:04
 * @LastEditors: Mr Chang
 * @Description:
 * @FilePath: \element3\packages\steps\src\constants.js
 */

export const stateSymbol = Symbol('state')

export const propsSymbol = Symbol('props')
